import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { ManualNotificationsItemFragment } from 'api';
import { LoadMoreQuery } from 'types/app';
import { LoadMoreButton } from 'components';

import Row from './Row';
import Loader from './Loader';

interface IProps {
  queryResult: LoadMoreQuery<ManualNotificationsItemFragment>;
}

const Sent: FC<IProps> = ({ queryResult }) => {
  const { t } = useTranslation();
  const { results, count, isExhausted, isLoading, isInitialLoad, onLoadMore } = queryResult;

  return (
    <Fragment>
      <Grid container alignItems="center" justify="space-between">
        <Grid item xs>
          <Typography paragraph variant="subtitle2">
            {t('messages:pastMessages')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography paragraph>{t('components:xResult', { count })}</Typography>
        </Grid>
      </Grid>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography noWrap>{t('messages:messageSent')}</Typography>
              </TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell align="center">
                <Typography>{t('messages:recipients')}</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {results.map(item => (
              <Row key={item.id} item={item} />
            ))}
            {isInitialLoad && <Loader />}
            {!isInitialLoad && !results.length && (
              <TableRow>
                <TableCell />
                <TableCell colSpan={4}>
                  <em>{t('components:noPastMessages')}</em>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {!isExhausted && <LoadMoreButton loading={isLoading} onClick={onLoadMore} />}
      </Paper>
    </Fragment>
  );
};

export default Sent;
